import React from 'react';
import classNames from 'classnames';
import { Chiclet as LTOChiclet } from '@nerdwallet/bain-components';
import classes from '@nerdwallet/base-styles/classes';
import { Type } from '@nerdwallet/currency';
import { formatValue } from '@nerdwallet/marketplace/utils/format';
import QuickFacts from '@nerdwallet/react-quick-facts';
import styles from "./keto-product-card.module.css";
var KetoBonusQuickFactSofi = function KetoBonusQuickFactSofi(_ref) {
  var quickFact = _ref.quickFact;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames([styles.cell, styles.value])
  }, /*#__PURE__*/React.createElement(Type, {
    className: classes(['type-2', 'type-3--wide'])
  }, formatValue(quickFact.value, quickFact.valueFormat)), /*#__PURE__*/React.createElement("div", {
    className: classes(['padding-vertical-1'])
  }, /*#__PURE__*/React.createElement(LTOChiclet, null)), quickFact.description && /*#__PURE__*/React.createElement(Type, {
    className: classes(['display-block']),
    color: "neutral-darker",
    size: 1
  }, quickFact.description));
};
if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');
  KetoBonusQuickFactSofi.propTypes = {
    quickFact: PropTypes.shape(QuickFacts.propTypes)
  };
}
export default KetoBonusQuickFactSofi;